// Recovered compiled webpack factory 98924. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return s;
      },
    }));
  let n = r(49417),
    a = r(95155),
    o = n._(r(12115)),
    i = r(46752);
  function s() {
    let e = (0, o.useContext)(i.TemplateContext);
    return (0, a.jsx)(a.Fragment, { children: e });
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
